import { CURRENCY } from './constans/constans';
import { Product } from '../models/Product';

export const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
};

export const filterObjectByKeys = (
    objToFilter: Record<string, unknown>,
    keys: string[]
) => {
    return Object.keys(objToFilter)
        .filter((key) => keys.includes(key))
        .reduce((obj, key) => {
            obj[key] = objToFilter[key];
            return obj;
        }, {});
};

export const objectHasKey = (
    object: Record<string, unknown>,
    key: string | number
) => {
    return Object.prototype.hasOwnProperty.call(object, key);
};

export const getShopifyID = (id: string) => {
    return id.split('/').slice(-1).toString();
};

export const getCurrency = (currencyCode) => {
    return CURRENCY[currencyCode];
};

export const getCollectionHandle = (handle) => {
    return handle.split('/').pop().toString();
};

export const convertProductsIds = (products: Product[]) => {
    return {
        productIds: products.map((elem) => {
            return {
                productId: getShopifyID(elem.id),
            };
        }),
    };
};

export const getNetPrice = (price: number): number => {
    return (price / 1.27);
}

export const isNullOrUndefinedOrEmpty = (value: unknown): boolean => {
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }

    if (typeof value === 'string' && value === '') {
        return true;
    }

    return isNullOrUndefined(value);
};